import { atom } from 'jotai'

import { type SurveyFilterGroups } from '~/utils'

import { auth0UserAtom } from './auth0UserAtom'
import { createAtomWithLocalStorage } from './utils'

const surveyIdAtom = atom('')

export const surveyFilterKeyAtom = atom(
  (get) => {
    const auth0User = get(auth0UserAtom)
    const surveyId = get(surveyIdAtom)

    return ['analyzer', surveyId, auth0User?.sub, 'surveyFilter'].join('::')
  },
  (_get, set, surveyId: string | undefined) => {
    set(surveyIdAtom, surveyId ?? '')
  },
)

export const surveyFilterAtom = createAtomWithLocalStorage<{
  count: number
  filterGroups: SurveyFilterGroups
}>((get) => get(surveyFilterKeyAtom))
